/**
 * `matchMedia` como estado do React, para escolher ENTRE duas arvores em vez
 * de renderizar as duas e esconder uma com CSS.
 *
 * A regua usa isto para decidir entre a grade (md+) e o carrossel de um toque
 * por vez (telas estreitas): quatro cartoes de toque com copy inteira, e-mail
 * e metricas duplicados no DOM so para o CSS esconder metade seria o dobro do
 * custo de render para o celular -- justamente o aparelho mais fraco.
 */

import { useEffect, useState } from 'react';

export function useMediaQuery(consulta: string): boolean {
  const [casa, setCasa] = useState<boolean>(() => (typeof window === 'undefined' ? false : window.matchMedia(consulta).matches));

  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const aoMudar = (e: MediaQueryListEvent): void => {
      setCasa(e.matches);
    };
    setCasa(mq.matches);
    mq.addEventListener('change', aoMudar);
    return () => {
      mq.removeEventListener('change', aoMudar);
    };
  }, [consulta]);

  return casa;
}
